import Contact from '@/pages/Contact';

export default [
    {
        name: 'Contact',
        path: '/contact',
        component: Contact,
        meta: {
            middleware: {
            },
            nav: {
                addToNav: true,
                navText: 'Rakesh Sipai | Contact',
                navIcon: '',
            }
        }
    }
]